import {
  MaterialSymbol,
  PolymorphicMaterialSymbolProps,
} from "react-material-symbols";

export const Icon = ({
  onClick,
  ...props
}: PolymorphicMaterialSymbolProps<"span">) => {
  return onClick ? (
    <span
      onClick={onClick}
      onMouseDown={props.onMouseDown}
      style={{ display: "flex" }}
    >
      <MaterialSymbol {...props} />
    </span>
  ) : (
    <MaterialSymbol {...props} />
  );
};
